import type { InputProps } from '@/components/control/components/input/input.types';
import { filterInput } from '@/utils/helper';
import { autocompleteFor } from '@/utils/autofill';
import '@/components/control/components/input/input.css';

export default function Input(props: InputProps) {
  const {
    id,
    value,
    disabled = false,
    type = 'text',
    inputMode,
    filter,
    onAutofill,
    onAutofillCancel,
    onChange,
    onFocus,
    onBlur,
  } = props;
  return (
    <input
      disabled={disabled}
      type={type}
      inputMode={inputMode}
      id={id}
      name={id}
      autoComplete={autocompleteFor(id)}
      value={value}
      className='control-input'
      onChange={(e) => onChange(filterInput(e, filter), id, 'keyboard')}
      onAnimationStart={(e) => {
        if (e.animationName === 'autofill-start') onAutofill?.call(null, id);
        if (e.animationName === 'autofill-cancel') onAutofillCancel?.call(null, id);
      }}
      onFocus={() => onFocus?.call(null, id)}
      onBlur={() => onBlur?.call(null, id)}
    />
  );
}
